import * as React from 'react';
import { TModalContextValues } from './ModalContext.types';
import { TModalFooterProps } from 'components';
import { MODALS } from 'constants/modalKeys';

export const ModalContext = React.createContext<TModalContextValues>({
  name: null,
  isOpen: false,
  modalProps: null,
  footerProps: null,
  openModal: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    modalKey: keyof typeof MODALS,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    props?: Record<string, unknown>
  ) => {},
  closeModal: () => {},
});

export const ModalsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [name, setName] = React.useState<string | null>(null);
  const [isOpen, setIsOpen] = React.useState(false);
  const [modalProps, setModalProps] = React.useState<Record<
    string,
    unknown
  > | null>(null);
  const [footerProps, setFooterProps] =
    React.useState<TModalFooterProps | null>(null);
  const closingTimeout = React.useRef<NodeJS.Timeout | null>(null);

  const clearName = React.useCallback(() => {
    setName(null);
    setModalProps(null);
    setFooterProps(null);
  }, []);

  const openModal = React.useCallback(
    (
      modalKey: keyof typeof MODALS,
      props?: Record<string, unknown>,
      footerProps?: TModalFooterProps
    ) => {
      if (closingTimeout.current) clearTimeout(closingTimeout.current);

      setName(MODALS[modalKey]);
      setModalProps(props || null);
      setFooterProps(footerProps || null);
      setIsOpen(true);
    },
    []
  );

  const closeModal = React.useCallback(() => {
    setIsOpen(false);

    if (closingTimeout.current) clearTimeout(closingTimeout.current);
    closingTimeout.current = setTimeout(clearName, 500);
  }, [clearName]);

  return (
    <ModalContext.Provider
      value={{
        name,
        isOpen,
        modalProps,
        footerProps,
        openModal,
        closeModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};
